export default "__VITE_ASSET__BOQO7F1a__"